import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">Energy Solutions Chile</h3>
            <p className="text-gray-600 dark:text-gray-400">
              Shaping Chile's energy future with innovative infrastructure solutions.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="#focus-areas" className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">
                  Focus Areas
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-600 dark:text-gray-400">
              <li>Project Development</li>
              <li>Project Design</li>
              <li>Environmental Approvals</li>
              <li>Grid Agreements</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Technologies</h4>
            <ul className="space-y-2 text-gray-600 dark:text-gray-400">
              <li>Solar PV</li>
              <li>Wind Power</li>
              <li>Hydroelectric</li>
              <li>Natural Gas</li>
              <li>Data Centers</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-300 dark:border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 Energy Solutions Chile. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;